import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogWrapper } from '@common/components/modal/dialog-wrapper';
import {
  AnniversaryEvent,
  BirthdayEvent,
  EEventTypes,
} from '@modules/calendar/types/events';
import Profile from '@common/components/profile';
import { useParams } from 'react-router';
import LinkWrapper from '@common/components/linkWrapper';

type CelebrationModelProps = {
  selectedCelebration: BirthdayEvent | AnniversaryEvent;
  show: boolean;
  onClose: () => void;
};

const CelebrationModel = memo(
  ({ selectedCelebration, show, onClose }: CelebrationModelProps) => {
    const { t } = useTranslation();
    const { networkId } = useParams<{ networkId: string }>();

    const handleHide = () => {
      onClose();
    };

    return (
      <DialogWrapper
        show={show}
        onHide={handleHide}
        title={
          selectedCelebration.type === EEventTypes.BIRTHDAY
            ? t('social:birthdays')
            : t('social:anniversaries')
        }
        hideFooter
        content={
          <div className="BirthdaysList ">
            {selectedCelebration?.users?.map((user: any) => (
              <div
                className="tw-flex tw-items-center tw-justify-between tw-mx-[20px] tw-py-[12px]"
                key={user.id}
              >
                <LinkWrapper
                  url={networkId ? `/networks/${networkId}/users/${user.id}/about` : `/admin/users/${user.id}/about`}
                  className="hover:tw-text-inherit hover:tw-underline"
                >
                  <Profile enablePopover size={40} user={user}>
                    {selectedCelebration.type === EEventTypes.BIRTHDAY ? (
                      null
                    ) : (
                      <p className="tw-text-gray-custom-430 tw-m-0 tw-pt-1">
                        {t('social:anniversary_in_years', { count: user.year })}
                      </p>
                    )}
                  </Profile>
                </LinkWrapper>
              </div>
            ))}
          </div>
        }
      />
    );
  }
);

export default CelebrationModel;
